import React, { Component } from 'react';
import { connect } from 'react-redux';
import './TransferWorkOrder.css';
import Button from 'components/shared/button/Button';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import {
  updateGc,
  changeWorkOrderClient,
  finishTransfer,
  selectClient,
  setShowModal,
} from 'components/admin/work-orders/details/transfer/store/actions';
import PropTypes from 'prop-types';
import AssignModal from 'components/admin/work-orders/details/transfer/AssignModal';
import SelectClientModal from 'components/admin/work-orders/details/transfer/SelectClientModal';
import {
  selectedClientSelector,
  showMessageModalSelector,
  showModalSelector,
} from 'components/admin/work-orders/details/transfer/store/selectors';
import MessageModal from 'components/shared/modal/MessageModal';
import { clientsApi } from 'services/api/clients-api';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import { cancelWorkOrderRequest } from 'actions/admin/work-orders/work-orders';

class TransferWorkOrder extends Component {
  static propTypes = {
    currentWorkOrder: PropTypes.shape({}).isRequired,
    selectedClient: PropTypes.shape({}),
    showMessageModal: PropTypes.bool.isRequired,
    showModal: PropTypes.bool.isRequired,
    onClientConfirm: PropTypes.func.isRequired,
    onClientSelect: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onAssignConfirm: PropTypes.func.isRequired,
    onTransferClick: PropTypes.func.isRequired,
    onDeleteConfirm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedClient: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      showAssignModal: false,
      showDeleteConfirmation: false,
    };
  }

  static loadClients(value, currentClientId) {
    return clientsApi.searchByCompanyName(value).then((response) => {
      if (response.ok) {
        return {
          ok: true,
          options: response.clients
            .filter((client) => client.id !== currentClientId)
            .map((element) => {
              return {
                value: element.id,
                label: element.company_name,
              };
            }),
        };
      } else {
        return {
          ok: false,
          errors: response.errors,
        };
      }
    });
  }

  handleAssign = () => {
    const { showAssignModal } = this.state;
    this.setState({ showAssignModal: !showAssignModal });
  };

  handleAssignConfirm = (gcId) => {
    const { currentWorkOrder, onAssignConfirm } = this.props;
    this.setState({ showAssignModal: false });
    onAssignConfirm(currentWorkOrder.id, gcId);
  };

  handleConfirm = () => {
    this.props.onClientConfirm(
      this.props.currentWorkOrder.id,
      this.props.selectedClient.value
    );
  };

  handleMessageModalHide = () => {
    this.props.onFinish();
  };

  handleDelete = () => {
    this.setState({ showDeleteConfirmation: true });
  };

  handleDeleteConfirmationModalHide = (confirmation) => {
    if (confirmation) {
      this.props.onDeleteConfirm(this.props.currentWorkOrder.id);
    }
    this.setState({ showDeleteConfirmation: false });
  };

  render() {
    const {
      currentWorkOrder,
      currentWorkOrder: { general_contractor },
      selectedClient,
      showModal,
      onClientSelect,
      onTransferClick,
    } = this.props;
    const { showAssignModal } = this.state;
    let message = '';
    if (selectedClient !== null) {
      message = `Work Order #${currentWorkOrder.number} has been transferred to ${selectedClient.label}`;
    }
    const assignInitialValues = {
      selectedGc: general_contractor && {
        value: general_contractor.id,
        label: general_contractor.name,
      },
    };

    return (
      <div className="transfer-work-order">
        <Button
          className="button-white"
          label="Assign"
          onClick={this.handleAssign}
        />

        <Button
          className="button-orange"
          label="Transfer"
          onClick={() => onTransferClick(true)}
        />

        <Button
          className="button-gray"
          label="Delete"
          onClick={this.handleDelete}
        />

        {showAssignModal && (
          <AssignModal
            initialValues={assignInitialValues}
            show={showAssignModal}
            onClose={this.handleAssign}
            onConfirm={this.handleAssignConfirm}
          />
        )}

        <SelectClientModal
          loadOptions={(value) =>
            TransferWorkOrder.loadClients(value, currentWorkOrder.client.id)
          }
          selectedClient={selectedClient}
          show={showModal}
          onClientSelect={onClientSelect}
          onClose={() => onTransferClick(false)}
          onConfirm={this.handleConfirm}
        />

        <MessageModal
          show={this.props.showMessageModal}
          message={message}
          onHide={this.handleMessageModalHide}
        />

        <ConfirmationModal
          show={this.state.showDeleteConfirmation}
          message={'Are you sure you want to delete this Work Order?'}
          onHide={this.handleDeleteConfirmationModalHide}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    selectedClient: selectedClientSelector(state),
    showMessageModal: showMessageModalSelector(state),
    showModal: showModalSelector(state),
  };
}

const mapDispatchToProps = (dispatch) => ({
  onAssignConfirm: (workOrderId, gcId) => {
    dispatch(updateGc(workOrderId, gcId));
  },
  onClientConfirm: (workOrderId, clientId) => {
    dispatch(changeWorkOrderClient(workOrderId, clientId));
  },
  onClientSelect: (client) => {
    dispatch(selectClient(client));
  },
  onFinish: () => {
    dispatch(finishTransfer());
  },
  onTransferClick: (value) => {
    dispatch(setShowModal(value));
  },
  onDeleteConfirm: (workOrderId) => {
    dispatch(cancelWorkOrderRequest(workOrderId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferWorkOrder);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/transfer/TransferWorkOrder.js